import HTTP from '@/components/general/http/http'

import config from '@/config/env'

export default {
	getSellersTypes(data) {

		let url = config.api.baseUrl + '/api/sellersTypes' + data

		return HTTP
			.request()
			.get(url)
			.then(response => response)
			.catch(error => error)


	},
	createSellerType(data) {

		let url = config.api.baseUrl + '/api/sellersTypes'

		return HTTP
			.request()
			.post(url, data)
			.then(response => response)
			.catch(error => error)

	},
	updateSellerType(data) {

		let url = config.api.baseUrl + '/api/sellersTypes'

		return HTTP
			.request()
			.put(url, data)
			.then(response => response)
			.catch(error => error)

	},
	deleteSellerType(data) {

		let url = config.api.baseUrl + '/api/sellersTypes' + data

		return HTTP
			.request()
			.delete(url)
			.then(response => response)
			.catch(error => error)

	}
}



// WEBPACK FOOTER //
// ./src/api/sellers-types.js